import React, { useEffect, useState } from "react";
import {
  eye_icon,
  logo,
  user_icon,
  lock_img,
} from "../../assets/imgs";
import { Outlet, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useLoginMutation } from "../redux/api/api";
import { Spinner } from "react-bootstrap";
import VisibilityIcon from '@mui/icons-material/Visibility';

const Login = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [Password, setPassword] = useState("");
  const [nameErr, setNameErr] = useState(false);
  const [PassErr, setPassErr] = useState(false);
  const [loader, setLoader] = useState(false);
  const [visible, setVisible] = useState(false);

  const [loginApi] = useLoginMutation();


  const token = localStorage.getItem("token");


  useEffect(() => {
    if (token) {
      navigate("/dashboard")
    } else {
      navigate("/");
    }
  }, [])

  const login = () => {

    if (!username) {
      toast.error("Enter Username")
      return
    }
    if (!Password) {
      toast.error("Enter Password")
      return
    }
    setLoader(true)
    const formdata = new FormData();
    formdata.append("username", username);
    formdata.append("password", Password);

    loginApi(formdata)
      .unwrap()
      .then((res) => {
        console.log(res);
        if (res?.status == "success") {
          setLoader(false);
          toast.success(res?.message);
          localStorage.setItem("token", res?.token);
          localStorage.setItem("loggedUser", JSON.stringify(res?.admin));
          localStorage.setItem("permissions", JSON.stringify(res?.permissions));
          setTimeout(() => {
            navigate("/welcome");
            window.location.reload();
          }, 500);
        } else {
          setNameErr(true);
          setPassErr(true);
        }
      })
      .catch((err) => {
        console.log(err);
      }).finally(() => {
        setLoader(false)
      })
  };



  return (
    <div className="login">
      <div className="login-details ">
        <div className="login-box">
          <h2 className="f4 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 yellow text-center mb-4">
            Welcome to Ziro Admin Login
          </h2>
          <div className="d-flex ac-jc">
            <img src={logo} className="logo-img" alt="" />
          </div>
          <div className="input-field mt-4">
            <img src={user_icon} className="email-icon" alt="" />
            <input
              type="email"
              className="cust-btn ps-2 w-90"
              placeholder="User Name"
              onChange={(e) => {
                setUsername(e.target.value);
                setNameErr(false);
              }}
              value={username}
            />
          </div>
          {nameErr && <p className="err">Enter User Name</p>}

          <div className="input-field mb-2 d-flex ac-jb mt-4">
            <div>
              <img src={lock_img} className="input-icon mb-2" alt="" />
              <input
                type={visible ? "text" : "password"}
                maxLength={20}
                className="cust-btn ps-2 w-90"
                placeholder="Password"
                onChange={(e) => {
                  setPassword(e.target.value);
                  setPassErr(false);
                }}
                value={Password}
              />
            </div>
            {!visible && (
              <img
                src={eye_icon}
                onClick={() => setVisible(!visible)}
                className="eye-icon pointer mb-1"
                alt=""
              />
            )}
            {visible && (
              <div onClick={() => setVisible(!visible)} className="pointer sec">
                <VisibilityIcon className="eye-icon " />
              </div>
            )}
          </div>
          {PassErr && <p className="err">Enter Password</p>}

          <div className="d-flex ac-jc mt-5">
            <button
              onClick={() => login()}
              className="login-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mb-0 "
            >
              {loader ? 'Loging In...' : 'Login'}
            </button>
          </div>
        </div>
      </div>
      {loader && (<div style={{ zIndex: 2000, position: "fixed", top: "45%", left: "49%", }}  >
        <Spinner animation="border" className="primary1" />
      </div>
      )}
    </div>
  );
};

export default Login;
